<template>
  <span class="value__span" v-if="!flag" @dblclick="handleClick">{{ modelValue }}</span>
  <el-input v-else ref="inputRef" class="db-Click__input" v-model="inputValue"
    @keyup.native.enter="handleInputMethods('enter')" @blur="handleInputMethods('blur')" @focus="saveInputValue"
    @input="handleMethods"></el-input>
</template>

<script setup>
import { throttle } from '@/utils/tools';
import { nextTick, ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
})

const emit = defineEmits(['valueChange', 'update:modelValue'])

const flag = ref(false)

const inputValue = ref('')
const handleMethods = (val) => {
  emit('update:modelValue', val)
}
const saveInputValue = (event) => {
  emit('focus:modelValue')
}
const inputRef = ref(null)
const handleClick = () => {
  flag.value = true
  inputValue.value = props.modelValue
  nextTick(() => {
    inputRef.value.focus()
    // const input = document.querySelector('.db-Click__input .el-input__inner')
    // input.focus()
  })
}

// 添加节流函数，防止回车事件和失去焦点事件同时触发
const handleInputMethods = throttle((type) => {
  if (flag.value) {
    type === 'blur' ? done() : null
    emit('valueChange', props.modelValue, done)
  }
}, 100)

const done = () => {
  flag.value = false
}

</script>

<style lang="less" scoped>
.value__span {
  width: 100%;
  display: inline-block;
  cursor: pointer;
}
</style>